// Research catalog API client.
//
// BE contract: /app/memory/VOYA9_BE_Research_Catalog_Contract.md
// Endpoints:
//   GET  /api/consumer/research/catalog          (auth optional)
//   GET  /api/consumer/research/catalog/:sku     (auth optional)
//   POST /api/consumer/research/checkout         (auth required)
//   GET  /api/consumer/research/orders           (auth required, v2)
//
// Pricing fields on items are integer cents — we display via fmtMoney.
import { apiGet, apiPost } from "@/lib/api";

export async function fetchResearchCatalog() {
  // Soft-auth call.
  //
  // The research catalogue endpoint is gated by the BE (returns 401 if
  // no JWT), but the page itself must render for BOTH authenticated
  // members AND anonymous visitors landing on the doctor-shared
  // `voya9.com/research` URL. So we:
  //   - DO send the Authorization header when a JWT is present (so
  //     signed-in members see the catalogue immediately).
  //   - Use `noAuthRedirect: true` so an anonymous 401 does NOT kick
  //     the visitor to /sign-in — they keep seeing the hero + auth
  //     strip and can browse without disruption.
  // The earlier `auth: false` shape silently dropped the JWT header
  // for signed-in users, which is why the catalogue stayed empty even
  // after a successful login. Bug fixed by switching to soft-auth.
  try {
    const data = await apiGet("/consumer/research/catalog", { noAuthRedirect: true });
    return {
      items: Array.isArray(data?.items) ? data.items : [],
      labCopy: data?.labCopy || null,
    };
  } catch (err) {
    if (err?.status === 404 || err?.status === 401) {
      return { items: [], labCopy: null, status: err?.status };
    }
    throw err;
  }
}

export async function startResearchCheckout({ items, successUrl, cancelUrl }) {
  // items: [{ sku, variant: 'subscription'|'one_time', quantity }]
  // returns { checkoutUrl }
  return apiPost("/consumer/research/checkout", { items, successUrl, cancelUrl });
}

// Restock notification signup.
//   POST /api/consumer/research/notify { sku, email }
// Anonymous or authed — both allowed. BE stores the pair and dispatches
// an email when the SKU flips back to `availability: in_stock`.
export async function notifyWhenAvailable({ sku, email }) {
  return apiPost("/consumer/research/notify", { sku, email });
}
